import {isHtoActive} from '../feature-flags'
import * as URLS from '../urls'

export const nav = {
  modifier: 'main',
  items: [
    {
      id: 20,
      current: false,
      dropdown: [
        {
          id: 1,
          href: URLS.COLLECTION_TUXEDOS_SUITS,
          title: 'Suits & Tuxedos',
          toSpa: true,
        },
        {
          id: 2,
          href: URLS.COLLECTION_SHIRTS,
          title: 'Shirts',
          toSpa: true,
        },
        {
          id: 3,
          href: URLS.COLLECTION_VESTS,
          title: 'Vests',
          toSpa: true,
        },
        {
          id: 5,
          href: URLS.COLLECTION_CUFFLINKS_STUDS,
          title: 'Cufflinks & Studs',
          toSpa: true,
        },
        {
          id: 6,
          href: URLS.COLLECTION_NECKWEAR,
          title: 'Neckwear',
          toSpa: true,
        },
        {
          id: 7,
          href: URLS.COLLECTION_SHOES,
          title: 'Shoes',
          toSpa: true,
        },
        {
          id: 8,
          href: URLS.COLLECTION_ACCESSORIES,
          title: 'Accessories',
          toSpa: true,
        },
      ],
      title: 'Rental',
      toSpa: true,
    },
    {
      id: 25,
      current: false,
      dropdown: [
        {
          id: 0,
          href: `${URLS.BUY_NEW_COLLECTIONS}/new-arrivals`,
          title: 'New Arrivals',
          toSpa: false,
        },
        {
          id: 1,
          href: `${URLS.COLLECTION_TUXEDOS_SUITS}?transaction-type=buy`,
          title: 'Suits & Tuxedos',
          toSpa: false,
        },
        {
          id: 2,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_SHIRTS_SLUG}`,
          title: 'Shirts',
          toSpa: false,
        },
        {
          id: 3,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_VESTS_SLUG}`,
          title: 'Vests',
          toSpa: false,
        },
        {
          id: 5,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_CUFFLINKS_STUDS_SLUG}`,
          title: 'Cufflinks & Studs',
          toSpa: false,
        },
        {
          id: 6,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_NECKWEAR_SLUG}`,
          title: 'Neckwear',
          toSpa: false,
        },
        {
          id: 7,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_SHOES_SLUG}`,
          title: 'Shoes',
          toSpa: false,
        },
        {
          id: 8,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.BUY_NEW_ACCESSORIES_SLUG}`,
          title: 'Accessories',
          toSpa: false,
        },
        {
          id: 9,
          href: `${URLS.BUY_NEW_COLLECTIONS}${URLS.SALE_COLLECTION}`,
          title: 'Sale',
          toSpa: false,
        },
      ],
      title: 'Buy New',
      toSpa: false,
      hasDivider: false,
      marketingText: 'The new way to own your look.',
    },
    {
      id: 21,
      current: false,
      dropdown: [
        {
          id: 0,
          href: URLS.HOW_IT_WORKS,
          title: 'Our Process',
          toSpa: true,
        },
        {
          id: 1,
          href: URLS.FIT_LP,
          title: 'Fit & Sizing',
          toSpa: true,
        },
        {
          id: 2,
          href: URLS.OUR_QUALITY,
          modifier: 'separator',
          title: 'A Quality Suit',
          toSpa: true,
        },
        {
          id: 3,
          href: URLS.PROM,
          title: 'Prom',
          toSpa: false,
        },
        {
          id: 4,
          href: URLS.WEDDINGS_LP,
          title: 'Weddings',
          toSpa: true,
        },
        {
          id: 5,
          href: URLS.TUXEDO_SUIT_RENTAL,
          title: 'Rentals',
          toSpa: true,
        },
      ],
      title: 'How It Works',
      toSpa: true,
    },
    {
      id: 23,
      current: false,
      href: URLS.HOME_TRY_ON,
      links: [],
      title: 'Home Try-On',
      toSpa: true,
    },
    {
      id: 24,
      current: false,
      href: URLS.SHOWROOMS,
      links: [],
      title: 'Showrooms',
      toSpa: true,
    },
    {
      id: 25,
      current: false,
      href: 'https://markenyc.com/pages/wedding-rings?utm_source=theblacktux&utm_medium=referral&utm_campaign=nav',
      links: [],
      openNewTab: true,
      title: 'Wedding Rings',
      toSpa: false,
    },
  ],
}

const navWithoutHto = {
  ...nav,
  items: nav.items.filter(({href}) => href !== URLS.HOME_TRY_ON),
}

export default isHtoActive ? nav : navWithoutHto

export const getAccountManagementLinks = ({onLogout}: {onLogout: () => void}) => [
  {name: 'My Events', href: '/account/events'},
  {name: 'My Sizes', href: '/fit/your-sizes'},
  {name: 'Account Info', href: '/account/info'},
  {name: 'Log Out', onClick: onLogout},
]
